import MfaTeamsPhoneMobileStepOne from './MfaTeamsPhoneMobileStepOne';

function MfaTeamsPhoneMobileWizard({ onClose }) {
    return <MfaTeamsPhoneMobileStepOne onClose={onClose} />;
}

export default MfaTeamsPhoneMobileWizard;
